import * as React from 'react';
import cn from 'classnames';
import * as styles from './styles.css';
import { InlineText2 } from '@cian/ui-kit';
import { FilterWrapper } from '../FilterWrapper';
import { jsx as _jsx } from "react/jsx-runtime";

/** Компонент для кнопки в строке фильтров, которая открывает дропдаун */
export var DropdownFilterButton = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var isEmpty = props.isEmpty,
      isActive = props.isActive,
      testId = props.testId,
      handleToggle = props.handleToggle,
      isFirstFilter = props.isFirstFilter,
      isLastFilter = props.isLastFilter,
      label = props.label;
  return /*#__PURE__*/_jsx(FilterWrapper, {
    isLastFilter: isLastFilter,
    isFirstFilter: isFirstFilter,
    children: /*#__PURE__*/_jsx("button", {
      ref: ref,
      type: "button",
      className: cn(styles['control-button'], isActive && styles['control-button--active'], isEmpty && styles['control-button--empty']),
      onClick: handleToggle,
      "data-testid": "".concat(testId, "_control"),
      children: /*#__PURE__*/_jsx(InlineText2, {
        color: "current_color",
        children: label
      })
    })
  });
});
DropdownFilterButton.displayName = 'DropdownFilterButton';